import { StyledInput } from './styledComponents';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';
import IconButton from 'common/buttons/IconButton';
import Typography from 'common/text/Typography';
import { forkRef } from 'common/utils/reactUtils';
import React, { CSSProperties, forwardRef, useRef } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import {
	StyledInputContainer,
	StyledLabel
} from "../SubtleTextBox/styledComponents";
import {StyledTextArea} from "./styledComponents";
import FlexContainer from "../../FlexContainer";

interface TextboxOverrides {
	root?: CSSProperties;
	button?: CSSProperties;
	label?: CSSProperties;
}

// TODO: create appropriate 'Omit' type to remove conflict between HTMLAttributes
// and UseFormRegisterReturn
export interface SubtleTextAreaProps
	extends UseFormRegisterReturn,
		Record<string, any> {
	isDirty: boolean;
	label: string;
	onReset?: () => void;
	error?: string;
	overrides?: TextboxOverrides;
	showLabel?: boolean;
}

const SubtleTextArea = forwardRef<HTMLTextAreaElement, SubtleTextAreaProps>(
	({ overrides, isDirty, showLabel, onReset, label, error, ...rest }, forwardedRef) => {
		const resetterRef = useRef<HTMLTextAreaElement>();

		const setRefs = forkRef(forwardedRef, resetterRef);

		return (
			<div style={{ position: 'relative', border: '1px solid transparent' }}>
				{showLabel && (
					<StyledLabel
						htmlFor={`${label}-subtle-input`}
						style={overrides?.label}
					>
						<Typography color='oldManGray' variant='h6'>
							{label}
						</Typography>
					</StyledLabel>
				)}
				<FlexContainer
						style={{width: '100%'}}
						alignItems='flex-start'
						justifyContent='flex-start'
					>
				<StyledTextArea
					spellCheck={false}
					style={overrides?.root}
					id={`${label}-subtle-input`}
					className={clsx(isDirty && 'is-dirty')}
					aria-invalid={Boolean(error)}
					aria-errormessage={`${label}-error-message`}
					// @ts-ignore
					ref={setRefs}
					aria-label={label}
					{...rest}
				/>
				{isDirty && (
					<IconButton
						style={{
							...overrides?.button,
							position: 'absolute',
							right: '4px',
							top: '4px',
						}}
						fillColor="error"
						size="xs"
						icon={faTimes}
						aria-label={`reset ${label} field`}
						tooltipPlacement="top"
						onClick={(e) => {
							e.preventDefault();
							onReset && onReset();
						}}
					/>
				)}
							</FlexContainer>
				<div>
					{error && (
						<Typography id={`${label}-error-message`} color="error" variant='h5'>
							{error}
						</Typography>
					)}
				</div>
			</div>
		);
	}
);

export default SubtleTextArea;
